/**
 * Maison Moxi: 'Without personalization' checkbox for personalized product templates.
 * Works with the Printify personalize app block (block id contains 'personalize_button').
 * The checkbox only shows when Printify actually shows its 'Add personalized design' button
 * (for products that are not personalized in Printify the button stays hidden, and so does the checkbox).
 * Checked: the Printify button is hidden and the line item property 'Personalization: None' is added to the
 * product form, so the order shows the customer chose the design as shown.
 * Unchecked: the Printify button is visible again and the property is removed.
 */
(function () {
  if (window.__mmPersonalizeToggle) return;
  window.__mmPersonalizeToggle = true;

  var LABEL = 'Without personalization';
  var NOTE = 'Order this design exactly as shown.';
  var PROP_NAME = 'properties[Personalization]';
  var PROP_VALUE = 'None';
  var BLOCK_SELECTOR = '.shopify-app-block[id*="personalize_button"]';

  function injectStyles() {
    if (document.getElementById('mm-personalize-toggle-styles')) return;
    var css =
      '.mm-pers{display:flex;align-items:flex-start;gap:10px;margin:0 0 10px;cursor:pointer;font-size:.875rem;line-height:1.35}' +
      '.mm-pers[hidden]{display:none}' +
      '.mm-pers input{position:absolute;opacity:0;width:1px;height:1px}' +
      '.mm-pers__box{flex:none;width:18px;height:18px;margin-top:1px;border:1.5px solid currentColor;border-radius:5px;display:grid;place-items:center;transition:background .15s ease}' +
      '.mm-pers__box svg{width:12px;height:12px;opacity:0;color:#fff}' +
      '.mm-pers input:checked + .mm-pers__box{background:currentColor}' +
      '.mm-pers input:checked + .mm-pers__box svg{opacity:1}' +
      '.mm-pers input:focus-visible + .mm-pers__box{outline:2px solid currentColor;outline-offset:2px}' +
      '.mm-pers__text{display:flex;flex-direction:column;gap:2px}' +
      '.mm-pers__label{font-weight:600;font-family:var(--font-subheading--family,inherit)}' +
      '.mm-pers__note{font-size:.8rem;opacity:.75}' +
      '.mm-pers-hidden{display:none !important}';
    var style = document.createElement('style');
    style.id = 'mm-personalize-toggle-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function productForm(near) {
    var scope = (near && near.closest('.shopify-section')) || document;
    return scope.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
  }

  function setProperty(form, on) {
    if (!form) return;
    var existing = form.querySelector('input[data-mm-pers-prop]');
    if (on && !existing) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = PROP_NAME;
      input.value = PROP_VALUE;
      input.setAttribute('data-mm-pers-prop', '');
      form.appendChild(input);
    } else if (!on && existing) {
      existing.remove();
    }
  }

  function printifyButton(block) {
    return block.querySelector('.personalize-button') || block.querySelector('button:not([class*="close"])');
  }

  function isShown(el) {
    return !!el && el.offsetParent !== null && el.getBoundingClientRect().height > 0;
  }

  function setup(block) {
    injectStyles();
    block.setAttribute('data-mm-pers-ready', '');
    var id = 'MmPers-' + Math.random().toString(36).slice(2, 8);
    var label = document.createElement('label');
    label.className = 'mm-pers';
    label.hidden = true;
    label.setAttribute('for', id);
    label.innerHTML =
      '<input type="checkbox" id="' + id + '">' +
      '<span class="mm-pers__box" aria-hidden="true"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M3.5 8.5l3 3 6-7"/></svg></span>' +
      '<span class="mm-pers__text"><span class="mm-pers__label">' + LABEL + '</span><span class="mm-pers__note">' + NOTE + '</span></span>';
    block.parentNode.insertBefore(label, block);
    block.__mmPersLabel = label;

    var checkbox = label.querySelector('input');
    checkbox.addEventListener('change', function () {
      block.classList.toggle('mm-pers-hidden', checkbox.checked);
      setProperty(productForm(block), checkbox.checked);
    });
  }

  function sync(block) {
    if (!block.hasAttribute('data-mm-pers-ready')) setup(block);
    var label = block.__mmPersLabel;
    if (!label) return;
    if (block.classList.contains('mm-pers-hidden')) return; // customer chose 'without': keep checkbox visible
    var show = isShown(printifyButton(block));
    if (label.hidden === show) label.hidden = !show;
  }

  function scan() {
    document.querySelectorAll(BLOCK_SELECTOR).forEach(sync);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  window.addEventListener('load', scan);
  new MutationObserver(scan).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden']
  });
})();
